import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function SummerShop({ brand, isActive, width }) {
    const sunColor = brand === MISFITS_THEME_DOMAIN ? '#F1C34A' : '#F7D46D';
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';

    return isActive ? (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5908_1051)">
                <path
                    d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                    fill={activeColor}
                />
                <path
                    d="M12.5498 3.71341C12.415 3.55131 12.1693 3.57701 12.0632 3.74054L12.027 3.81853L10.8889 7.54076C10.7636 7.95061 10.3386 8.1895 9.92328 8.08359L6.02902 7.09063C5.82167 7.03809 5.63705 7.2087 5.65206 7.4055L5.67111 7.49032L7.0009 11.0221C7.15784 11.4395 6.94465 11.9046 6.52587 12.0579L2.79248 13.4253C2.55694 13.5116 2.52273 13.8305 2.73464 13.9649L5.96543 16.0126C6.35141 16.2574 6.45543 16.7751 6.19415 17.15L4.00608 20.2875C3.86256 20.4934 4.01753 20.7752 4.2682 20.7637L8.23974 20.5807C8.68542 20.5602 9.06206 20.9075 9.07845 21.3533L9.21706 25.1237C9.22502 25.3376 9.44086 25.466 9.62547 25.3961L9.70165 25.3539L12.9094 22.9328C13.2514 22.6747 13.7357 22.7308 14.0098 23.0602L16.4985 26.0541C16.6524 26.2388 16.9508 26.1789 17.0212 25.9489L18.1582 22.2259C18.2757 21.8416 18.6574 21.6071 19.0468 21.6667L19.1248 21.6829L23.0181 22.6761C23.2552 22.7365 23.4622 22.5054 23.376 22.2764L22.0464 18.7456C21.8892 18.328 22.1032 17.862 22.5222 17.7086L26.2558 16.3422C26.4616 16.2665 26.513 16.013 26.3811 15.8608L26.3134 15.8016L23.0826 13.7539C22.6966 13.5091 22.5925 12.9914 22.8539 12.6165L25.042 9.479C25.1674 9.29889 25.0641 9.0617 24.8685 9.01283L24.7801 9.00373L20.8083 9.18583C20.3628 9.2063 19.9855 8.85992 19.9688 8.41431L19.83 4.64305C19.8208 4.39875 19.5407 4.26543 19.3454 4.41278L16.1387 6.83371C15.7966 7.09195 15.3113 7.03616 15.0373 6.70655L12.5498 3.71341Z"
                    fill={sunColor}
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3118 11.151C17.4706 10.3116 15.2262 8.84671 12.9777 9.70229C10.1671 10.7718 9.49009 12.4207 9.29781 13.9722"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.09485 15.4709C9.13384 15.6648 9.2274 16.1301 9.28978 16.4403"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.0776 20.1017C17.2692 19.789 19.7516 18.3841 20.1478 15.2653"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M2.80198 4.3272C2.15154 3.69461 0.732178 2.26367 0.732178 2.26367"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.90355 7.2066C1.31336 7.23697 -4.9806e-05 7.27127 -4.9806e-05 7.27127"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.56472 2.918C5.60119 2.32898 5.71289 1 5.71289 1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_5908_1051">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ) : (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5908_1043)">
                <path
                    d="M20.4249 5.19611C20.4309 4.9854 20.2295 4.84226 20.0418 4.89485L19.9632 4.92951L16.649 6.97067C16.284 7.19541 15.8072 7.09379 15.5655 6.73982L13.2993 3.42085C13.1784 3.24438 12.9271 3.2504 12.8083 3.40801L12.7666 3.48425L11.4303 7.01357C11.2722 7.43054 10.8048 7.63866 10.3892 7.47698L6.68373 6.03564C6.44989 5.94476 6.21347 6.16145 6.2837 6.40233L7.35485 10.0744C7.48277 10.5131 7.21865 10.9704 6.77477 11.0791L3.05909 11.9875C2.81534 12.0471 2.74534 12.3611 2.94105 12.5181L6.0425 15.0056C6.39049 15.2848 6.44361 15.7944 6.16125 16.1398L3.77339 19.0609C3.63799 19.2267 3.71505 19.4657 3.89979 19.5353L3.98486 19.554L7.99227 19.8571C8.41954 19.8894 8.74591 20.2517 8.73392 20.6799L8.62283 24.5715C8.61622 24.8119 8.87977 24.9642 9.0846 24.8381L12.3985 22.7956C12.7406 22.5849 13.1821 22.6612 13.4349 22.9633L13.4827 23.027L15.7481 26.3455C15.8861 26.5476 16.1942 26.5109 16.2809 26.2821L17.6166 22.7536C17.7746 22.3363 18.2433 22.1281 18.6591 22.2898L22.364 23.732C22.5685 23.8113 22.7747 23.655 22.7763 23.4536L22.7646 23.3645L21.6934 19.6924C21.5655 19.2536 21.8295 18.7963 22.2735 18.6877L25.9892 17.7793C26.2023 17.727 26.2816 17.4808 26.1671 17.3148L26.1067 17.2495L23.0058 14.7612C22.6579 14.4821 22.6037 13.9728 22.8857 13.6273L25.274 10.7054C25.4285 10.516 25.3064 10.2308 25.0625 10.2124L21.056 9.90974C20.6286 9.87744 20.3013 9.51486 20.3135 9.0864L20.4249 5.19611Z"
                    fill={sunColor}
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.8334 14.586C19.7569 13.4001 19.0408 10.8173 16.7879 9.97331C13.9718 8.91831 12.374 9.70833 11.2043 10.7456"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10.0614 11.7362C9.96252 11.9075 9.72522 12.3185 9.56702 12.5925"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12.241 19.8264C13.3419 20.3793 16.1334 20.9656 18.492 18.887"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_5908_1043">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

SummerShop.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SummerShop.defaultProps = {
    isActive: false,
    width: 30,
};
